import { createApiSlice } from 'app/createApiSlice'
import { API_USER_ITEMS, API_USER_ITEMS_SELECTION } from 'utils/apiList'

export const masterItemsApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'masterItems/api',
  endpoints(builder) {
    return {
      // GET: Fetch all master items with pagination and search
      fetchMasterItems: builder.query({
        query({
          page = 0,
          size = 10,
          sortby = 'name',
          sortdir = 'ASC',
          s,
          withSchema,
        }) {
          return {
            url: `/${API_USER_ITEMS}`,
            params: {
              page,
              size,
              sortBy: sortby,
              sortdir,
              s,
              ...(withSchema !== undefined && withSchema !== 'all'
                ? { withSchema }
                : {}),
            },
          }
        },
      }),

      fetchMasterItemsSelection: builder.query({
        query({ page = 0, size = 10, sortby = 'name', sortdir = 'ASC', s, origin }) {
          return {
            url: `/${API_USER_ITEMS_SELECTION}`,
            params: {
              page,
              size,
              sortBy: sortby,
              sortdir,
              s,
              ...(origin !== undefined ? { origin } : {}),
            },
          }
        },
      }),

      // GET: Fetch single master item by ID
      getMasterItemById: builder.query({
        query(id) {
          return {
            url: `${API_USER_ITEMS}/${id}`,
            method: 'GET',
          }
        },
      }),

      // POST: Create new master item
      createMasterItem: builder.mutation({
        query({ id, ...payload }) {
          let url = API_USER_ITEMS
          if (id) {
            url += `/${id}`
          }
          return {
            url,
            method: 'POST',
            body: payload,
          }
        },
      }),

      // PUT: Update master item
      updateMasterItem: builder.mutation({
        query({ id, ...payload }) {
          return {
            url: `${API_USER_ITEMS}/update/${id}`,
            method: 'POST',
            body: payload,
          }
        },
      }),

      // DELETE: Soft delete master item
      deleteMasterItem: builder.mutation({
        query(id) {
          return {
            url: `${API_USER_ITEMS}/${id}`,
            method: 'DELETE',
          }
        },
      }),
    }
  },
})

export const {
  useFetchMasterItemsQuery,
  useLazyFetchMasterItemsQuery,
  useGetMasterItemByIdQuery,
  useLazyGetMasterItemByIdQuery,
  useCreateMasterItemMutation,
  useUpdateMasterItemMutation,
  useDeleteMasterItemMutation,
  useFetchMasterItemsSelectionQuery,
} = masterItemsApiSlice
